import { VendorSearch, VendorSearchResult } from "@/types/Vendor";
import { adminBaseQueryWrapper } from "@/utils/rtkHelper";
import { createApi } from "@reduxjs/toolkit/query/react";

export const vendorBankDetailApi = createApi({
  reducerPath: "vendorBankDetailApi",
  baseQuery: adminBaseQueryWrapper,
  tagTypes: ["vendorBankDetail"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getVendorsBankDetailById: builder.query<any, any>({
      query: ({ id }) => `/vendor-bank-detail/${id}`,
      providesTags: ["vendorBankDetail"],
    }),
    getBankDetailByVendorId: builder.query<any, any>({
      query: ({ id }) => `/vendor-bank-detail/vendors/${id}`,
      providesTags: ["vendorBankDetail"],
    }),
    searchVendorsBankDetail: builder.query<VendorSearchResult, VendorSearch>({
      query: (input) => ({
        url: `/vendor-bank-detail/search`,
        method: "POST",
        body: input,
      }),
      providesTags: ["vendorBankDetail"],
    }),
    createVendorsBankDetail: builder.mutation<void, any>({
      query: (input) => ({
        url: `/vendor-bank-detail`,
        method: "POST",
        body: input,
      }),
      invalidatesTags: ["vendorBankDetail"],
    }),
    updateVendorsBankDetail: builder.mutation<void, { id: string; data: any }>({
      query: ({ id, data }) => ({
        url: `/vendor-bank-detail/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["vendorBankDetail"],
    }),
  }),
});

export const {
  useGetVendorsBankDetailByIdQuery,
  useGetBankDetailByVendorIdQuery,
  useCreateVendorsBankDetailMutation,
  useUpdateVendorsBankDetailMutation,
  useSearchVendorsBankDetailQuery,
} = vendorBankDetailApi;
